var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowCircleLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/arrow-circle-left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/arrow-circle-left_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-circle-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.0003 2.71245C8.65366 2.71245 2.66699 8.69911 2.66699 16.0458C2.66699 23.3924 8.65366 29.3791 16.0003 29.3791C23.347 29.3791 29.3337 23.3924 29.3337 16.0458C29.3337 8.69911 23.347 2.71245 16.0003 2.71245ZM18.387 20.0458C18.7737 20.4324 18.7737 21.0724 18.387 21.4591C18.187 21.6591 17.9337 21.7524 17.6803 21.7524C17.427 21.7524 17.1737 21.6591 16.9737 21.4591L12.267 16.7524C11.8803 16.3658 11.8803 15.7258 12.267 15.3391L16.9737 10.6324C17.3603 10.2458 18.0003 10.2458 18.387 10.6324C18.7737 11.0191 18.7737 11.6591 18.387 12.0458L14.387 16.0458L18.387 20.0458Z",
    fill: "white"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleLeft);
export default __webpack_public_path__ + "static/media/arrow-circle-left.a69f631c047fc4d2fca7c71dac430f93.svg";
export { ForwardRef as ReactComponent };